export enum ROUTE_NAMES {
  HOME = "home",
  DASHBOARD = "dashboard",
  MEASURES = "measures",
  AVERAGE_PROCESSING_TIME = "averageProcessingTime",
  FINDING_TYPES = "findingTypes",
  MEASURE_TYPES = "measureTypes",
  MEASURES_DUE_DATE = "measuresDueDate"
}
